import { useCallback } from 'react';
import { useAppDispatch } from 'store/store';
import { useNavigate } from 'features/cobrand/hooks/useCobrandUtils';
import { SignupStep } from '../types';
import { useSignupData } from './useSignupData';
import { openExitDialog, setStepStack } from '../signUpSlice';

export const useSignupSectionNavigation = () => {
  const appDispatch = useAppDispatch();
  const { stepStack, currentStep } = useSignupData();
  const navigate = useNavigate();

  const navigateToNextStep = useCallback(
    (step: SignupStep) => {
      if (stepStack.includes(step)) {
        console.warn(`Step ${step} is already in the stack.`);
        return;
      }
      appDispatch(setStepStack([...stepStack, step]));
    },
    [appDispatch, stepStack, setStepStack],
  );

  const navigateToPreviousStep = useCallback(() => {
    if (stepStack.length === 1) {
      navigate('/login');
      return;
    }
    if (currentStep === 'AccessCodeMatched') {
      appDispatch(openExitDialog());
      return;
    }
    const newStack = stepStack.slice(0, -1);
    appDispatch(setStepStack(newStack));
  }, [appDispatch, stepStack, setStepStack]);

  const resetNavigation = useCallback(() => {
    appDispatch(setStepStack(['AccessCodeSubmission']));
  }, [appDispatch, setStepStack]);

  return {
    navigateToNextStep,
    navigateToPreviousStep,
    resetNavigation,
  };
};
